import { useDispatch, useSelector } from 'react-redux';
import { ComponentName } from '../constants';
import { RootState } from '../state';
import {
  ModalPayload,
  disableModal,
  enableModal,
  getModalData,
  getModalName,
} from '../state/reducers/modals';

interface ModalContext {
  activeModals: ModalPayload[];
  allActiveModals: ComponentName[];
  activeModal?: ComponentName;
  enableModal: (name: ComponentName | ModalPayload) => void;
  disableModal: (name: ComponentName | ModalPayload) => void;
  getModalState: (name: ComponentName) => ModalPayload | undefined;
}

export function useModal(): ModalContext {
  const state = useSelector((state: RootState) => state.modals);
  const dispatch = useDispatch();

  const currentActiveModalName =
    state.length > 0 ? getModalName(state[0]) : undefined;

  return {
    activeModals: state,
    allActiveModals: state.map(modal => getModalName(modal)),
    activeModal: currentActiveModalName,
    enableModal: (payload: ComponentName | ModalPayload) =>
      dispatch(
        enableModal({
          name: getModalName(payload),
          data: getModalData(payload),
        }),
      ),
    disableModal: (payload: ComponentName | ModalPayload) =>
      dispatch(
        disableModal({
          name: getModalName(payload),
          data: getModalData(payload),
        }),
      ),
    getModalState: (name: ComponentName) =>
      state.find(modal => getModalName(modal) === name),
  };
}
